import React from "react";
import { Box } from "digiwash-components";
import { color as colorUtil } from "@sloth-system/styled-utils";
import theme from "../../configs/theme-config";

interface RadioButtonType {
  selected: boolean;
}

function RadioButton(props: RadioButtonType) {
  return (
    <Box
      br="circle"
      style={{
        width: 20,
        height: 20,
        borderWidth: props.selected ? 1 : 2,
        borderColor: colorUtil("primary.main")({ theme: theme }),
        borderStyle: "solid",
      }}
      bg="common.white"
      p="s"
    >
      <Box
        bg={props.selected ? "primary.main" : "common.white"}
        br="circle"
        style={{ width: "100%", height: "100%" }}
      ></Box>
    </Box>
  );
}

export default RadioButton;
